<template>
	<v-navigation-drawer
		v-model="isDisplayMenu"
		temporary
		absolute
		:width="menuWidth"
		id="drawer"
		class="mobile-menu"
	>
		<v-container class="mobile-menu__content" v-bind:style="{ height: menuHeight }">
			<v-btn class="mobile-menu__close-btn elevation-0" @click="closeMenu(false)">
				<v-icon> mdi-close</v-icon>
			</v-btn>
			<v-list>
				<v-list-item
					v-for="link in prettyAppBaseMenu"
					:key="link.id"
					class="mobile-menu-list__item"
				>
					<v-list-item-content
						v-if="link.route.name === 'web-view'"
						class="mobile-menu-list__content"
					>
						<a
							@click.prevent="toggleLink(link.params.url)"
							target="_self"
							class="text-decoration-none"
						>
							<v-list-item-title class="mobile-menu-list__title text-wrap">
								{{ link.title }}
							</v-list-item-title>
						</a>
					</v-list-item-content>
					<v-list-item-content v-else class="mobile-menu-list__content">
						<router-link :to="link.route" exact class="text-decoration-none">
							<v-list-item-title class="mobile-menu-list__title text-wrap">
								{{ link.title }}
							</v-list-item-title>
						</router-link>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<div class="mobile-menu-list__title cursor-pointer text-wrap px-4 mt-3">
				<p class="mobile-menu__settings" @click="toSettings">Settings</p>
			</div>
			<div class="mobile-menu__logout-wrapper cursor-pointer px-4">
				<p class="mobile-menu__logout" @click="exit">Logout</p>
			</div>
		</v-container>
	</v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'MobileMenu',
	props: {
		isAuth: {
			type: Boolean,
			default: false,
		},
		profileSettings: {
			type: Array,
			default: () => [],
		},
		categories: {
			type: Array,
			default: () => [],
		},
		userAvatar: {
			type: String,
			default: null,
		},
		displayMenu: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		...mapActions('auth', ['logout', 'getMapRegisterToken']),
		isMapUrlValid(url) {
			try {
				const arr = JSON.parse(this.appCore.parsing_url)
				const link = new URL(url)
				return arr.some((allowed) => link.origin === allowed)
			} catch (e) {
				console.error(e)
				return false
			}
		},
		async toggleLink(link) {
			const target = link

			if (!target) return

			if (this.isMapUrlValid(target)) {
				try {
					await this.getMapRegisterToken()
					if (!this.mapRegisterToken) {
						console.error('Token not received')
						return
					}
					const urlWithToken = `${target}${target.includes('?') ? '&' : '?'}code=${
						this.mapRegisterToken
					}`
					window.open(urlWithToken, '_self')
				} catch (e) {
					console.error(e)
				}
			} else {
				window.open(target, '_self')
			}
		},

		closeMenu(value) {
			this.$emit('closeMenu', value)
		},
		toSettings() {
			this.$router.push({ name: 'settings' })
		},
		exit() {
			this.logout()
		},
		shouldHideMenuItem(item) {
			if (item.block === 2) {
				return true
			}
			if (item.role !== null && this.userIsMember) {
				return false
			}
			if (item.chapters && item.chapters.length) {
				const hasAccess = item.chapters.some((chapterId) =>
					this.userChapters.some((userChapter) => userChapter.chapter_id === chapterId)
				)
				if (!hasAccess) {
					return true
				}
			}
			return false
		},
	},
	computed: {
		...mapGetters('settings', ['appCore']),
		...mapGetters('auth', ['profile', 'mapRegisterToken']),

		isDisplayMenu: {
			get() {
				return this.displayMenu
			},
			set(value) {
				this.closeMenu(value)
			},
		},
		menuWidth() {
			return (this.$vuetify.breakpoint.width / 100) * 72 + ''
		},
		menuHeight() {
			return this.$vuetify.breakpoint.height + 'px'
		},
		userIsMember() {
			return this.profile.is_member
		},
		userChapters() {
			return this.profile.chapters.filter((chapter) => !chapter.hidden_subgroup)
		},
		prettyAppBaseMenu() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.baseMenuItems.filter((item) => {
				if (!item.title || !item.route) {
					return false
				}
				if (item.chapters && item.chapters.length) {
					let result = false
					item.chapters.forEach((chapter) => {
						if (this.userChapters.some((item) => item.chapter_id === chapter)) {
							result = true
						}
					})
					if (!result) {
						return result
					}
				}
				if (item.role === null || (item.block && item.block === 2)) {
					return true
				} else if ((item.role && this.userIsMember) || (!item.role && !this.userIsMember)) {
					return true
				}
				return false
			})
		},
	},
}
</script>

<style lang="scss">
.mobile-menu {
	position: fixed;

	&__content {
		padding: 24px 16px 0 calc(100vw / 10);
		display: flex;
		flex-direction: column;
		overflow-y: auto;

		@media (max-width: 360px) {
			padding-left: 16px !important;
		}
	}

	&__close-btn {
		background-color: var(--accent-color) !important;
		color: #fff !important;
		margin-left: -16px;
		max-width: 64px;
	}

	&-list {
		&__content {
			padding: 20px 0 !important;
		}

		&__title {
			font-size: 20px;
			font-family: Montserrat, sans-serif;
			line-height: 22px;
			font-weight: 700;
			color: #fff;

			@media (max-width: 360px) {
				font-size: 16px;
				line-height: 19.5px;
				font-weight: 500;
			}
		}
	}

	&__logout,
	&__settings {
		margin-bottom: 30px !important;
		font-size: 20px;
		font-family: Montserrat, sans-serif;
		line-height: 22px;
		font-weight: 700;
		color: #fff;

		@media (max-width: 360px) {
			margin-bottom: 20px;
			font-size: 16px;
			line-height: 19.5px;
			font-weight: 500;
		}

		&-wrapper {
			flex-grow: 1;
			display: flex;
			align-items: flex-end;
			margin-top: 32px;
		}
	}

	.v-navigation-drawer__content {
		background-color: var(--accent-color);
	}
}
</style>
